module.exports = __webpack_public_path__ + "img/zxxqy.5a4e287b.png";